<template>
  <div class="wrapper">

    <div class="header_wrapper">
      <v-toolbar color="primary" class="position-relative">
        <v-btn
          @click="routerBack"
          icon
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>

        <v-toolbar-title 
          class="flex-grow-1 text-center ml-0"
          style="pointer-events: none;"
        >
          各種設定
        </v-toolbar-title>
        <v-btn icon disabled style="visibility: hidden">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-toolbar>
    </div>

    <div>
      <v-list>
        <!-- keyは template タグのみに付与します -->
        <template v-for="(m, index) in menus" :key="m.type">
          <v-list-item @click="clickMenu(m)">
            
            <!-- メインテキスト: v-list-item-title を使用 -->
            <v-list-item-title class="subtitle-1">{{ m.title }}</v-list-item-title>

            <!-- 右側のアイコン: append スロットを使用 -->
            <template v-slot:append>
              <div class="badge d-flex justify-center align-center mr-2">
                <v-icon>mdi-chevron-right</v-icon>
              </div>
            </template>

          </v-list-item>

          <v-divider />
        </template>
      </v-list>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';
import { when } from '@/service/Switch';

import { auth0Module } from '@/store/entityModules/auth0';

enum MenuType {
  PASSWORD = 'password',
  NOTIFICATION = 'notification',
  FAMILY = 'family',
  LANGUAGE = 'language',
  TERMS_OF_SERVICE = 'termas_of_service',
  PRIVACY_POLICY = 'privacy_policy',
  TRANSACTIONS_LAW = 'transactions_law',
  PAYMENT = 'payment',
  LOGOUT = 'logout',
}

interface Menu {
  type: MenuType;
  title: string;
  path: string;
}

interface DataType {
  menus: Menu[];
}

export default defineComponent({

  data: (): DataType => ({
    menus: [
      // {
      //   type: MenuType.PASSWORD,
      //   title: 'パスワード設定',
      //   path: '/setting/password',
      // },
      {
        type: MenuType.FAMILY,
        title: '家族設定',
        path: '/setting/family',
      },
      {
        type: MenuType.PAYMENT,
        title: '支払設定',
        path: '/payment/select',
      },
      {
        type: MenuType.NOTIFICATION,
        title: '通知設定',
        path: '/setting/notification',
      },
      // {
      //   type: MenuType.LANGUAGE,
      //   title: '言語の設定（Language setting）',
      //   path: '/setting/language',
      // },
      // {
      //   type: MenuType.TERMS_OF_SERVICE,
      //   title: '利用規約',
      //   path: '/setting/terms_of_service',
      // },
      // {
      //   type: MenuType.PRIVACY_POLICY,
      //   title: 'お問い合わせ',
      //   path: '/setting/privacy_policy',
      // },
      // {
      //   type: MenuType.TRANSACTIONS_LAW,
      //   title: '特定商取引に基づく表記',
      //   path: '/setting/transactions_law',
      // },
      {
        type: MenuType.LOGOUT,
        title: 'ログアウト',
        path: '/',
      },
    ],
  }),

  methods: {
    routerBack() {
      this.$router.replace('/setting');
    },
    clickMenu(menu: Menu) {
      when(menu.type)
        .on((v) => v === MenuType.LOGOUT, () => {
          auth0Module.logout();
        })
        .otherwise(() => {
          this.$router.push(menu.path);
        });
    },
  },

});
</script>
<style lang="scss" scoped>
.wrapper {
  padding-top: calc(var(--app-top-offset) + 56px);
  margin-bottom: calc(env(safe-area-inset-bottom) + 56px);
}

/* ヘッダー */
.header_wrapper {
  height: 56px;
  width: 100%;
  position: fixed;
  top: var(--app-top-offset); /* ← これが超重要 */
  left: 0;
  z-index: 100;

  .outline {
    border: 1px solid rgb(var(--v-theme-primary));
  }

  .content_wrapper {
    min-height: calc(100% - 56px);
    margin: 56px 0 0px;
    overflow-y: hidden;
  }
}
</style>
